import { Outlet } from 'react-router'

export function AppsMarketingPage() {
  return <Outlet />
}
